import * as React from "react";
import styled from "@emotion/styled";
import AWS from "aws-sdk";
AWS.config.update({ region: "eu-west-2" });
AWS.config.accessKeyId = "AKIAT426G72SU7LUUAON";
AWS.config.secretAccessKey = "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";
let s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: "feedback-sunrise-gp" },
});
/**
 * FeedbackChap
 * AKIAT426G72SU7LUUAON
 *I7IyFObq/A9KQmBiiKDmTFq1YBSFDT1GLReMb+rj
 */

console.log("Version 1.0");

const PracticeNames = [
  "Aspen Medical Practice",
  "Bartongate Surgery",
  "Brunston & Lydbrook Practice, The",
  "Churchdown Surgery",
  "Coleford Family Doctors",
  "Cotswold Medical Practice",
  "Drybrook Surgery",
  "Locking Hill Surgery",
  "Longlevens Surgery",
  "Lydney Practice, The",
  "Newnham Surgery",
  "Painswick Surgery",
  "Partners in Health",
  "The Pheonix Group",
  "Rendcomb Surgery",
  "Severnbank Surgery",
  "Staunton & Corse Surgery",
  "Stonehouse Health Clinic",
  "The Acorn Practice",
  "The Alney Practice",
  "Walnut Tree Practice",
  "Beeches Green Surgery",
  "Berkeley Place Surgery",
  "Brockworth Surgery",
  "Cam and Uley Family Practice",
  "Campden Surgery",
  "Church Street Medical",
  "Crescent Bakery Surgery",
  "Dockham Road Surgery",
  "Frampton Surgery",
  "Frithwood Surgery",
  "George Whitefield Centre",
  "Gloucester Health Access Centre",
  "High Street Medical Centre",
  "Hilary Cottage Surgery",
  "Hucclecote Surgery",
  "Kingsholm Surgery",
  "Leckhampton Surgery",
  "Mann Cottage Surgery",
  "Marybrook Medical Centre",
  "Minchinhampton Surgery",
  "Mitcheldean Surgery",
  "Mythe Medical Practice",
  "Newent Family Practice",
  "Overton Park Surgery",
  "Portland Surgery",
  "Prices Mill Surgery",
  "Regent Street Surgery",
  "Rowcroft Medical Centre",
  "Royal Crescent Surgery   ",
  "Seven Post Surgery",
  "Sixways Clinic",
  "Springbank Surgery",
  "St George's Surgery",
  "Stoke Road Surgery",
  "Stow Surgery",
  "Stroud Valleys Family Practice",
  "The Avenue Surgery",
  "The Chipping Surgery",
  "The Culverhay Surgery",
  "Underwood Surgery",
  "Upper Thames Medical Group",
  "White House Surgery",
  "Winchcombe Medical Centre",
  "Yorkleigh Surgery",
  "Yorkley & Bream Practice",
  "Blakeney Surgery",
  "Corinthian Surgery",
  "Forest Health Care",
  "Gloucester City Health Centre",
  "Hadwen Medical Practice, The",
  "Quedgeley Medical Centre",
  "Rosebank Health",
  "St Catherine’s Surgery",
  "The Royal Well Surgery",
].sort();

const GridTitles = [
  "COVID status",
  "Patient list - ED",
  "Patient list - Inpatient",
  "Patient List - Discharged",
  "Outpatient letters",
  "Correspondence from GHFT to other care providers",
  "Patient location / Current Ward",
  "Consultant",
  "Radiology Reports: Echo, XRay, USS",
  "Radiology Images",
  "Pathology Results",
  "Clinical Observations: BP, Pulse, Resps, O2 Sats",
  "Admission documentation",
  "Discharge planning documentation",
  "Discharge Summaries",
];

const RootDiv = styled.div`
  padding-top: 20px;
  padding-right: 100px;
  padding-left: 100px;
  padding-bottom: 20px;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;

  margin-top: 20px;
  margin-bottom: 20px;

  background-color: #00000022;
`;

const GridTable = styled.div`
  width: 100%;

  border-style: solid;
  border-color: #00000022;
  border-width: 1px;
  padding: 10px;

  & > table > tr > td {
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    & > input {
      padding: 0px;
      margin: 0px;
    }
  }
`;

let GridRefs = GridTitles.map((t) => ({
  routinely: React.createRef<HTMLInputElement>(),
  extent: React.createRef<HTMLInputElement>(),
  never: React.createRef<HTMLInputElement>(),
  purpose: React.createRef<HTMLInputElement>(),
}));

export default function App() {
  let nameRef = React.useRef<any>(null);
  let roleRef = React.useRef<any>(null);
  let practiceNameRef = React.useRef<any>("-1");

  let [q01, setQ01] = React.useState("-1");
  let q01SelectRef = React.useRef<any>(null);
  let q01TextAreaRef = React.useRef<any>(null);

  let q03 = React.useState("-1");
  let q03TextAreaRef = React.useRef<any>(null);
  let q04Ref = React.useRef<any>(null);

  let accessibility_q01 = React.useState("-1");
  let accessibility_q01TextAreaRef = React.useRef<any>(null);

  let accessibility_q02 = React.useState("-1");
  let accessibility_q02TextAreaRef = React.useRef<any>(null);

  let ease_q01 = React.useState("-1");
  let ease_q01TextAreaRef = React.useRef<any>(null);

  let shortInterview = React.useState("-1");
  let shortInterviewAreaRef = React.useRef<any>(null);

  let [isSubmitting, setIsSubmitting] = React.useState(false);
  let [submitted, setSubmitted] = React.useState(false);
  async function submit() {
    setIsSubmitting(true);
    let submitObject: any = {
      name: nameRef.current.value,
      role: roleRef.current.value,
      practiceName: practiceNameRef.current.value,
      q01,
      q01Select: q01SelectRef?.current?.value,
      q01Text: q01TextAreaRef?.current?.value,
      q03: q03[0],
      q03Text: q03TextAreaRef?.current?.value,
      q04: q04Ref?.current?.value,

      accessibility_q01: accessibility_q01[0],
      accessibility_q01Text: accessibility_q01TextAreaRef?.current?.value,

      accessibility_q02: accessibility_q02[0],
      accessibility_q02Text: accessibility_q02TextAreaRef?.current?.value,

      ease_q01: ease_q01[0],
      ease_q01Text: ease_q01TextAreaRef?.current?.value,

      shortInterview: shortInterview[0],
      shortInterviewAreaRef: shortInterviewAreaRef?.current?.value,

      date: new Date(),
    };

    GridTitles.map((t, index) => {
      submitObject[`q02_${index}_info`] = t;
      submitObject[`q02_${index}_routinely`] =
        GridRefs[index]?.routinely?.current?.checked;
      submitObject[`q02_${index}_purpose`] =
        GridRefs[index]?.purpose?.current?.value;
      submitObject[`q02_${index}_extent`] =
        GridRefs[index]?.extent?.current?.checked;
      submitObject[`q02_${index}_never`] =
        GridRefs[index]?.never?.current?.checked;
    });

    s3.putObject(
      {
        Bucket: "feedback-sunrise-gp",
        Key: `feedback_${new Date().getTime()}.json`,
        Body: JSON.stringify(submitObject),
      },
      (err, data) => {
        if (err) {
          alert(err);
        } else {
          setSubmitted(true);
        }

        console.log({ err, data });

        setIsSubmitting(false);
      }
    );

    console.log({ submitObject });
  }

  if (submitted) {
    return (
      <RootDiv
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="App"
      >
        <h1>Thanks for your submission!</h1>
      </RootDiv>
    );
  }

  return (
    <RootDiv className="App">
      <h2 style={{ textAlign: "center" }}>
        An Evaluation of the use of Sunrise EPR in Primary Care Settings
      </h2>
      <label>Your name:</label>
      <input ref={nameRef} placeholder="name" />
      <label>Your role:</label>
      <input ref={roleRef} placeholder="role" />
      <label>Practice name:</label>
      <select ref={practiceNameRef}>
        <option value="-1">{"-- Please select --"}</option>
        {PracticeNames.map((t) => (
          <option value={t}>{t}</option>
        ))}
      </select>
      <Separator />
      <label>Have you used Sunrise EPR?</label>
      <select value={q01} onChange={(evt) => setQ01(evt.target.value)}>
        <option value="-1">{"-- Please select --"}</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>

      {q01 === "No" && (
        <React.Fragment>
          <label>Why not?</label>
          <select ref={q01SelectRef}>
            <option value="-1">{"-- Please select --"}</option>
            <option value="Not aware it is available">
              Not aware it is available
            </option>
            <option value="Too difficult to access">
              Too difficult to access
            </option>
            <option value="The data is of no value">
              The data is of no value
            </option>
            <option value="Other">Other</option>
          </select>
        </React.Fragment>
      )}

      {q01 != "-1" && (
        <React.Fragment>
          <label>
            Please provide further comment to support your choice above:
          </label>
          <textarea ref={q01TextAreaRef} />
        </React.Fragment>
      )}

      {q01 == "Yes" && (
        <React.Fragment>
          <Separator />
          <label>
            Please indicate which of the following patient data recorded in
            Sunrise you have routinely used to support patient care. Please
            provide a brief description of the purpose:
          </label>
          <GridTable>
            <table>
              <tr>
                <th>
                  <b>Sunrise Information</b>
                </th>
                <th>
                  <b>Routinely</b>
                </th>
                <th>
                  <b>To some extent</b>
                </th>
                <th>
                  <b>Never</b>
                </th>

                <th>
                  <b>For what purpose?</b>
                </th>
              </tr>

              {GridTitles.map((t, index) => (
                <tr>
                  <td>
                    <span>{t}</span>
                  </td>
                  <td>
                    <div>
                      <input
                        ref={GridRefs[index].routinely}
                        type="radio"
                        name={t}
                      />
                    </div>
                  </td>

                  <td>
                    <div>
                      <input
                        ref={GridRefs[index].extent}
                        type="radio"
                        name={t}
                      />
                    </div>
                  </td>

                  <td>
                    <div>
                      <input
                        ref={GridRefs[index].never}
                        type="radio"
                        name={t}
                      />
                    </div>
                  </td>

                  <td>
                    <input ref={GridRefs[index].purpose} />
                  </td>
                </tr>
              ))}
            </table>
          </GridTable>
          <Separator />
          <label>
            Are there any particular patient cohorts/groups that benefit by you
            having access to the information in Sunrise?
          </label>
          <select value={q03[0]} onChange={(evt) => q03[1](evt.target.value)}>
            <option value="-1">{"-- Please select --"}</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {q03[0] === "Yes" && (
            <React.Fragment>
              <label>Which group(s)? Please describe the benefits</label>
              <textarea ref={q03TextAreaRef} />
            </React.Fragment>
          )}
          <label>
            Is there any information you expected to see in Sunrise that is not
            available?
          </label>
          <textarea ref={q04Ref} />
          <Separator />
          <h3>Accessibility</h3>
          <label>Is it easy to login to Sunrise?</label>
          <select
            value={accessibility_q01[0]}
            onChange={(evt) => accessibility_q01[1](evt.target.value)}
          >
            <option value="-1">{"-- Please select --"}</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {accessibility_q01[0] === "No" && (
            <React.Fragment>
              <label>Please describe what has been difficult:</label>
              <textarea ref={accessibility_q01TextAreaRef} />
            </React.Fragment>
          )}
          <label>
            Once logged in, does your connection remain persistent and stable?
          </label>
          <select
            value={accessibility_q02[0]}
            onChange={(evt) => accessibility_q02[1](evt.target.value)}
          >
            <option value="-1">{"-- Please select --"}</option>
            {["Yes, always", "Mostly", "Sometimes", "Never"].map((t) => (
              <option value={t}>{t}</option>
            ))}
          </select>
          {["Mostly", "Sometimes", "Never"].includes(accessibility_q02[0]) && (
            <React.Fragment>
              <label>Please describe what issues you have experienced:</label>
              <textarea ref={accessibility_q02TextAreaRef} />
            </React.Fragment>
          )}
          <Separator />
          <h3>Ease of Use</h3>
          <label>
            Once logged into Sunrise itself, is it easy to find the information
            you require?
          </label>
          <select
            value={ease_q01[0]}
            onChange={(evt) => ease_q01[1](evt.target.value)}
          >
            <option value="-1">{"-- Please select --"}</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {ease_q01[0] === "No" && (
            <React.Fragment>
              <label>Please describe what has been difficult:</label>
              <textarea ref={ease_q01TextAreaRef} />
            </React.Fragment>
          )}
          <Separator />
          Many thanks for your feedback. <br />
          <br /> Please indicate below if you would be happy to participate in a
          short interview regarding your use of Sunrise EPR.
          <br />
          <br />
          <select
            value={shortInterview[0]}
            onChange={(evt) => shortInterview[1](evt.target.value)}
          >
            <option value="-1">{"-- Please select --"}</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {shortInterview[0] === "Yes" && (
            <React.Fragment>
              <label>Please fill contact information:</label>
              <textarea ref={shortInterviewAreaRef} />
            </React.Fragment>
          )}
        </React.Fragment>
      )}

      <button
        disabled={isSubmitting}
        style={{ width: "100%" }}
        onClick={submit}
      >
        Submit
      </button>
    </RootDiv>
  );
}
